import { Check } from 'lucide-react';
import { cn } from '@/lib/utils/utils';

export type PlusFeatureCheckProps = {
  /** Багцад багтсан — ногоон featured icon (Figma Featured icon). */
  variant: 'included' | 'checkbox';
  /** Зөвхөн `checkbox` — сонгогдсон эсэх. */
  checked?: boolean;
  className?: string;
};

export function PlusFeatureCheck({
  variant,
  checked = false,
  className,
}: PlusFeatureCheckProps) {
  if (variant === 'included') {
    return (
      <span
        className={cn(
          'flex h-5 w-5 shrink-0 items-center justify-center rounded-xl bg-success-100 p-0.5',
          className
        )}
        aria-hidden
      >
        <Check className="h-4 w-4 text-success-400" strokeWidth={2.5} />
      </span>
    );
  }

  return (
    <span
      className={cn(
        'flex h-4 w-4 shrink-0 items-center justify-center rounded border border-primary-700 bg-primary-50',
        className
      )}
      aria-hidden
    >
      {checked ? (
        <Check className="h-3 w-3 text-primary-700" strokeWidth={3} />
      ) : null}
    </span>
  );
}
